import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { SEARCH_ENDPOINT, COMMUNITIES_ENDPOINT, UNIVERSITY_ENDPOINT, SUPPORT4YOU_ENDPOINT } from '../app.constants';
import { SiteSearchResult } from '../interfaces/site-search-result.interface';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SearchService {

    constructor(private http: HttpClient) {}

    getCppSearchCount(
        query: string,
        productId: string = ''
    ): Observable<SiteSearchResult> {
        return this.http.get<SiteSearchResult>(SEARCH_ENDPOINT + '/count', {
            params: { productId, query }
        });
    }
    // Hide knowledge articles coming from support.
    // getKnowledgeSearchCount(query: string, productId: string = '', userType: string): Observable<any> {
    //   return this.http.get<any>(SUPPORT_ENDPOINT + '/knowledge-article/count', {
    //     params: { productId, query, userType }
    //   });
    // }

    getCommunitySearchCount(query: string): Observable<any> {
        return this.http.get<any>(COMMUNITIES_ENDPOINT + '/search/count', {
            params: { query },
        });
    }
    getSupport4USearchCount(query: string, userId: string): Observable<any> {
        return this.http.get<any>(SUPPORT4YOU_ENDPOINT + '/count', {
            params: { userId, query },
        });
    }

    getUniversitySearchCount(query: string): Observable<any> {
        return this.http.get<any>(UNIVERSITY_ENDPOINT + '/search/count', {
            params: { query },
        });
    }

    getCombinedSearchCount(query: string, productId: string = ''): Observable<any[]> {
        return forkJoin([
            this.getCppSearchCount(query, productId).pipe(catchError(e => of(e))),
            // this.getKnowledgeSearchCount(encodeURIComponent(query), productId, userType).pipe(catchError(e => of(e))),
            this.getCommunitySearchCount(query).pipe(catchError(e => of(e))),
        ]);
    }

    getUniversitySearchCountTemporalSolution(query: string): Observable<any>{
        return this.getUniversitySearchCount(query).pipe(catchError(e => of(e)));
    }
}
